<div class="login-bg" fxLayout="column" fxLayoutAlign="center center" *ngIf="!isAuthentic">
    <h2 translate>Sign in or Register</h2>
    <div class="loging-register-dialog">
        <td-login-register [notDialog]="true" (loginResponse)="checkAuthentication()"></td-login-register>
    </div>
</div>